var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-picker',{ref:"picker",attrs:{"auto-apply":"","show-ranges":"","opens":"right","time-picker":_vm.timePicker,"time-picker-increment":5,"disabled":_vm.disabled,"max-date":_vm.maxDate},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }